import { render } from "./03_HouseholdInformationSection.vue?vue&type=template&id=66573ee0"
import script from "./03_HouseholdInformationSection.vue?vue&type=script&lang=js"
export * from "./03_HouseholdInformationSection.vue?vue&type=script&lang=js"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__